import { render, staticRenderFns } from "./EditVersionCaja.vue?vue&type=template&id=f44a2a04"
import script from "./EditVersionCaja.vue?vue&type=script&lang=js"
export * from "./EditVersionCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports